import { render, staticRenderFns } from "./teacherCardOrder.vue?vue&type=template&id=2e1af964&scoped=true&"
import script from "./teacherCardOrder.vue?vue&type=script&lang=js&"
export * from "./teacherCardOrder.vue?vue&type=script&lang=js&"
import style0 from "./teacherCardOrder.vue?vue&type=style&index=0&id=2e1af964&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1af964",
  null
  
)

export default component.exports